module.exports = __webpack_public_path__ + "img/icon_email.869e3cb.svg";